import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UserModel } from "../models/user.model";
import { UserClient, UserDto } from "../services/bpp.webapi/client";
import { Roles } from "../models/enums";
import { Observable } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";

@Injectable()
export class OAuthService {
  private userRole: Roles | undefined;
  private isAuth = false;
  private redirectUrl = "/";
  private isLog = false;
  private previousUrl: string;
  private currentUrl: string;

  constructor(
    private userClient: UserClient,
    private configService: ConfigService,
    private router: Router,
  ) {
    this.isLog = this.configService.isDebug();
    this.currentUrl = this.router.url;
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  login() {
    if (this.isLog) {
      console.log("OAuthService => Login...", this.redirectUrl);
    }
    window.location.href = this.redirectUrl;
  }

  logout() {
    if (this.isLog) {
      console.log("OAuthService => Logout...");
    }
    this.isAuth = false;
    window.location.href = this.redirectUrl;
  }

  getUser(): Observable<UserModel> {
    return this.userClient.getUser().pipe(
      map((result: UserDto) => {
        if (result) {
          console.log("Auth result:", result.authenticated);
          this.isAuth = result.authenticated;
          this.redirectUrl = result.redirectUrl;
          this.userRole = Roles[result.roles && result.roles[0]];

          // Map UserDto to UserModel
          const user = new UserModel();
          user.email = result.account || "";
          user.firstName = result.name || "";
          user.role = this.userRole;
          user.id = "";
          user.lastName = "";
          user.photo = null;
          user.companyName = "";
          user.companyId = "";
          user.isCompanyEnabledForNonLiveInUK = false;

          return user;
        }
        return null as any as UserModel;
      }),
    );
  }

  getUserRole(): Roles | undefined {
    return this.userRole;
  }

  getPreviousUrl() {
    return this.previousUrl;
  }

  isAuthenticated(): boolean {
    return (
      this.isAuth &&
      (this.userRole === Roles.Broadcaster ||
        this.userRole === Roles.PLPBroadcaster ||
        this.userRole === Roles.Club ||
        this.userRole === Roles.League ||
        this.userRole === Roles.Admin)
    );
  }
}
